module.exports = __webpack_public_path__ + "media/icons/circle-7ec25ada.svg";